export default "__VITE_ASSET__1d516519__"